module.exports = __webpack_public_path__ + "static/media/parts_27.66ee4373.svg";